import * as _ from "lodash";

import { Link } from "react-router-dom";
import React from "react";
import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";

const BudgetTypeSelect = ({
  value,
  intl,
  history,
  role,
  path
}) => {

  // console.log("role=", role);
  let options = [];

  if (role === "ADMIN") {
    options =
      [
        {
          value: "BUDGETS_CLIENT",
          label: intl.formatMessage({ id: "ids_budgetClient" })
        },
        {
          value: "BUDGET_CATEGORY",
          label: intl.formatMessage({ id: "ids_budgetCategory" })
        },
        {
          value: "ETAT_BUDGET_CLIENT",
          label: intl.formatMessage({ id: "ids_budgetClientReport" })
        },
        {
          value: "ETAT_BUDGET_CATEGORY",
          label: intl.formatMessage({ id: "ids_budgetCategoryReport" })
        }
      ];
  }
  else if (role === "COMPTABLE" || role === "COMMERCIAL") {
    options =
      [
        {
          value: "BUDGETS_CLIENT",
          label: intl.formatMessage({ id: "ids_budgetClient" })
        },
        {
          value: "ETAT_BUDGET_CLIENT",
          label: intl.formatMessage({ id: "ids_budgetClientReport" })
        }
      ];
  }

  return (
    <div className="space-between full-width">
      <SimpleSelect
        name="budgetType"
        value={value}
        onSelected={choice => {
          if (choice.value !== value) {
            switch (choice.value) {
              case "BUDGETS_CLIENT":
                history.push("/budget/clients");
                break;

              case "BUDGET_CATEGORY":
                history.push("/budget/categories");
                break;

              case "ETAT_BUDGET_CLIENT":
                history.push("/budget/clientReport");
                break;

              case "ETAT_BUDGET_CATEGORY":
                history.push("/budget/categoryReport");
                break;
            }
          }
        }}
        options={options}
        clearable={false}
        centered={true}
      />
    </div>
  );
};

export default BudgetTypeSelect;